import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { SalesOrderOutline } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1262. 以前のプロジェクト（売上）一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/prev_sales_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const prevSalesOrders = (props: Props): Promise<SalesOrderOutline[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/prev_sales_orders`
  );
};

export const usePrevSalesOrders = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => prevSalesOrders(props),
  });
};

export const useInvalidatePrevSalesOrders = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) }).then((r) => {});
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'prev_sales_orders'];
};
